enum TrackingAction {
    VWBasic_VehiclePromotionsAccordionOpen_Click = 'VWBasic_VehiclePromotionsAccordionOpen_Click',
    VWBasic_VehiclePromotionsAccordionClose_Click = 'VWBasic_VehiclePromotionsAccordionClose_Click',
    VWBasic_VehiclePromotionsLink_Click = 'VWBasic_VehiclePromotionsLink_Click',
    VWBasic_VehiclePromotionsButton_Click = 'VWBasic_VehiclePromotionsButton_Click',
    VWBasic_FilterSearchResult_Pageload = 'VWBasic_FilterSearchResult_Pageload',
    VWBasic_FilterSelect_Click = 'VWBasic_FilterSelect_Click',
    VWBasic_FilterSearchResult_Load = 'VWBasic_FilterSearchResult_Load',
    VWBasic_VehiclePromotionsSelect_Click = 'VWBasic_VehiclePromotionsSelect_Click',
    VWBasic_GenericFeatureApp_Load = 'VWBasic_GenericFeatureApp_Load',
    VWBasic_FilterReset_Click = 'VWBasic_FilterReset_Click',
    VWBasic_Button_Click = 'VWBasic_Button_Click',
    VWBasic_Teaser_Click = 'VWBasic_Teaser_Click',
    VWBASIC_FORM_SUBMISSION_SUCCESS_MESSAGE_LOAD = 'VWBasic_FormSubmissionSuccessMessage_Load',
    VWBASIC_FORM_ERROR_MESSAGE_LOAD = 'VWBasic_FormErrorMessage_Load',
    VWBASIC_FORM_CTA_CLICK = 'VWBasic_FormCTA_Click',
    VWBASIC_FORM_MODEL_SELECT_CLICK = 'VWBasic_ModelSelect_Click',
    VWBASIC_FORM_LAYER_LOAD = 'VWBasic_FormLayer_Load',
    VWBASIC_FORM_LAYER_CLOSE_CLICK = 'VWBasic_FormLayerClose_Click',
}
export default TrackingAction
